import { getCombinedStatus } from "./rsvnStatus";

export const buildWhatsAppMessage = (row) => {
  const status = getCombinedStatus(row);

  const formatTime = (time) => {
    if (!time) return "";
    const [hourStr, minute] = time.split(":");
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${minute} ${ampm}`;
  };

  const start = formatTime(row.startTime);
  const end = formatTime(row.endTime);

  let statusMessage = "";

  if (status === "confirmed") {
    statusMessage = "Your reservation has been confirmed.";
  } else if (status === "approved") {
    statusMessage = "Your reservation has been approved.";
  } else if (status === "paid") {
    statusMessage = "Your reservation payment has been received.";
  } else if (status === "pending") {
    statusMessage = "Your reservation is currently pending.";
  } else if (status === "cancelled") {
    statusMessage = "Your reservation has been cancelled.";
  }

  return `${statusMessage}

Booking Ref: ${row.bookingRef}
Name: ${row.name}
Venue: ${row.venue?.name || "-"}
Date: ${row.date}
Time: ${start} - ${end}

Thank you.`;
};